import React from 'react'

const NotFound = () => {
    return (
        <div>
            <h1> Erreure 404</h1>
            <br />
            <p> 
             Vous n'avez pas le droit d'acces a cette ressource
             bey Peter Centini
            </p>

        </div >
    )
}

export default NotFound
